export default "<p>settings works!</p>\r\n"